module.exports = __webpack_public_path__ + "img/bg.7722048a.webp";